module.exports = __webpack_public_path__ + "img/art-book.fd2572bd.png";